import { Button, Card } from '@iwoca/orion';
import RiveComponent, { Alignment, Fit, Layout } from '@rive-app/react-canvas';

// @ts-ignore
import CelebrationRive from './Components/Celebration.riv';
import { useAccountNavigation } from '../../../../hooks/useAccountNavigation';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { useEcomPostMessage } from '../../../hooks/useEcomPostMessage';
import { useIsOverlay } from '../../../hooks/useIsOverlay';
import { buildQueryString } from '../../../utils/queryParams';
import { useCurrentEcommerceOrder } from '../../hooks/useCurrentEcommerceOrder';
import { useCurrentPayLink } from '../../hooks/useCurrentPayLink';

export const DelayedPaylinkComplete = () => {
  const { navigateToAccount } = useAccountNavigation();
  const { ecommerceOrder } = useCurrentEcommerceOrder();
  const { payLink, loadingPayLink } = useCurrentPayLink();

  const isOverlay = useIsOverlay();
  useEcomPostMessage({
    enabled: isOverlay,
    status: 'SUCCESSFUL',
    redirectUrl: ecommerceOrder?.redirect_url,
  });

  if (loadingPayLink) return null;

  const handleRedirect = () => {
    if (ecommerceOrder && !isOverlay) {
      window.location.href = ecommerceOrder.redirect_url;
      return;
    }
    navigateToAccount(buildQueryString({ postCheckout: 'true' }));
  };

  return (
    <>
      <Card className="flex items-center !p-xl text-center">
        <RiveComponent
          src={CelebrationRive}
          className="ml-[80px] h-[230px] w-[230px]"
          layout={
            new Layout({ fit: Fit.Contain, alignment: Alignment.TopCenter })
          }
        />
        <h1 className="w-full text-center !text-2xl font-bold">
          You're all set!
        </h1>
        <p className="!mt-0 mb-xl text-l font-reg">
          Everything is now set up and ready to go. Once{' '}
          {payLink?.seller_trading_name} confirm the order, your payment
          schedule will begin. There’s nothing left for you to do.
        </p>
        <hr className="my-r h-[1px] w-full border-0 bg-structure-80" />
        <p className="mb-2xl mt-xl text-left text-m font-reg">
          We will send you an email once {payLink?.seller_trading_name} have
          confirmed the order and your payment schedule will begin. Your first
          payment will be 30 days after that date.
        </p>
        {isOverlay && (
          <p className="mb-2xl text-left text-m font-reg">
            You can now safely close this window and return to{' '}
            {payLink?.seller_trading_name}.
          </p>
        )}

        {!isOverlay && (
          <div className="w-full">
            <WhiteLabelOverride componentType="button" disabled={false}>
              <Button className="w-full" onClick={handleRedirect}>
                {ecommerceOrder
                  ? `Continue to ${payLink?.seller_trading_name}`
                  : 'Continue to dashboard'}
              </Button>
            </WhiteLabelOverride>
          </div>
        )}
      </Card>
    </>
  );
};
